import { useRouter } from 'vue-router';
import { useSessionStore } from '@/shared/stores/sessionStore';
import { useInboxStore } from '../stores/inboxStore';
import type { InboxNotification } from '../api/notificationApi';
import { resolveInboxLinkUrl } from '../utils/resolveInboxLinkUrl';

export function useInboxNavigation() {
  const router = useRouter();
  const sessionStore = useSessionStore();
  const inboxStore = useInboxStore();

  async function openNotification(item: InboxNotification, options?: { closeMenu?: boolean }) {
    if (inboxStore.isUnread(item)) {
      await inboxStore.markRead(item.notificationId);
    }

    if (!item.linkUrl) return;

    if (options?.closeMenu) {
      inboxStore.menuOpen = false;
    }

    const jurisdiction = sessionStore.getCustomerInfo()?.jurisdiction;
    const path = resolveInboxLinkUrl(item.linkUrl, jurisdiction);

    if (path.startsWith('http')) {
      window.open(path, '_blank', 'noopener');
      return;
    }

    const resolved = router.resolve(path);
    if (resolved.name === 'NotFound' || resolved.matched.length === 0) {
      console.warn('[Inbox] Unknown linkUrl, staying on page:', item.linkUrl, '→', path);
      return;
    }

    await router.push(path);
  }

  return { openNotification };
}
